import { render, staticRenderFns } from "./InfoCards.vue?vue&type=template&id=a5286368&scoped=true"
import script from "./InfoCards.vue?vue&type=script&lang=js"
export * from "./InfoCards.vue?vue&type=script&lang=js"
import style0 from "./InfoCards.vue?vue&type=style&index=0&id=a5286368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5286368",
  null
  
)

export default component.exports